/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import CONSTANTS from 'signer-app/signature-modal/constants';

import SignatureModal, {
  SignatureModalProps,
} from 'signer-app/signature-modal/signature-modal';
import SignatureModalV2 from 'signer-app/signature-modal/signature-modal-v2';

import { SignatureModalContextProvider } from 'signer-app/signature-modal/contexts/signature-modal/context';
import { CanvasContextProvider } from 'signer-app/signature-modal/contexts/canvas/context';
import { useFeatureFlag } from '../../js/sign-components/common/feature-flag';

export type ValueOfArray<T> = T[keyof T & number];

export type Tab = ValueOfArray<typeof CONSTANTS.TABS>;

export { CONSTANTS };

type Props = Omit<SignatureModalProps, 'canvasContext' | 'intl'>;

export default function SignIntegratedSignatureModal(props: Props) {
  const isNewSignerApp = useFeatureFlag('sign_core_20240330_new_signer_app');

  return (
    <CanvasContextProvider>
      <SignatureModalContextProvider>
        {isNewSignerApp ? (
          <SignatureModalV2 {...props} />
        ) : (
          <SignatureModal {...props} />
        )}
      </SignatureModalContextProvider>
    </CanvasContextProvider>
  );
}
